module.exports = __webpack_public_path__ + "assets/img/icon4.c29fa8a7.svg";